var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "no show",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1873 27.0454L13.1539 12.012C15.0352 10.3507 17.4966 9.33334 20.1993 9.33334C26.0806 9.33334 30.866 14.1187 30.866 20C30.866 22.7014 29.8486 25.1641 28.1873 27.0454ZM9.53256 20C9.53256 17.2974 10.5486 14.836 12.2112 12.9547L27.2446 27.9881C25.3633 29.6494 22.9006 30.6667 20.1993 30.6667C14.3179 30.6667 9.53256 25.8814 9.53256 20ZM20.1993 8C13.5712 8 8.19922 13.372 8.19922 20C8.19922 26.6281 13.5712 32.0001 20.1993 32.0001C26.8259 32.0001 32.1993 26.6281 32.1993 20C32.1993 13.372 26.8259 8 20.1993 8Z",
    fill: "#0049A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/Card2.0d7cf1bd8ea9f575cd0ad2d897cc41f3.svg";
export { ForwardRef as ReactComponent };